import type { Plurals, Strings } from '../index';

export const strings: Strings = {
  'menu.home': 'Accueil',
  'menu.notes': 'Notes',
  'menu.reminders': 'Rappels',
  'menu.passwords': 'Mots de passe',
  'menu.cards': 'Cartes',
  'menu.photoIds': 'Pièces d’identité',
  'menu.collections': 'Collections',
  'menu.conflicts': 'Conflits ({count})',
  'menu.settings': 'Paramètres',
  'menu.lock': 'Verrouiller le portefeuille',
  'menu.language': 'Langue',

  'type.note': 'Note',
  'type.note.plural': 'Notes',
  'type.password': 'Mot de passe',
  'type.password.plural': 'Mots de passe',
  'type.card': 'Carte',
  'type.card.plural': 'Cartes',
  'type.photoId': 'Pièce d’identité',
  'type.photoId.plural': 'Pièces d’identité',

  'section.upcoming': 'Rappels à venir',
  'section.pinned': 'Épinglés',
  'section.recent': 'Récents',
  'section.searchResults': 'Résultats de recherche',
  'section.conflicts': 'Conflits',

  'action.addNew': '+ Ajouter',
  'action.back': 'Retour',
  'search.placeholder': 'Rechercher ou ajouter',

  'gate.title': 'Tout ce qui compte',
  'gate.copy': 'Votre portefeuille est chiffré sur cet appareil avant toute synchronisation.',
  'gate.create': 'Créer un nouveau portefeuille',
  'gate.open': 'Ouvrir mon portefeuille existant',
  'gate.recover': 'Récupérer l’accès au portefeuille',

  'empty.addFirst': 'Ajoutez votre premier élément.',
  'empty.nothingHere': 'Rien ici pour l’instant.',
  'empty.noResults': 'Aucun élément enregistré ne correspond à cette recherche.',

  'action.cancel': 'Annuler',
  'action.save': 'Enregistrer',
  'action.saving': 'Enregistrement…',
  'action.close': 'Fermer',
  'action.edit': 'Modifier',
  'action.delete': 'Supprimer',
  'action.remove': 'Retirer',
  'action.change': 'Modifier',
  'action.clear': 'Effacer',
  'action.add': 'Ajouter',
  'action.show': 'Afficher',
  'action.hide': 'Masquer',
  'action.more': 'Plus',

  'field.title': 'Titre',
  'field.body': 'Contenu',
  'field.username': 'Nom d’utilisateur',
  'field.password': 'Mot de passe',
  'field.website': 'Site web',
  'field.notes': 'Notes',
  'field.cardNumber': 'Numéro de carte',
  'field.documentNumber': 'Numéro du document',
  'field.expiry': 'Expiration',
  'field.securityCode': 'Code de sécurité',
  'field.cvv': 'CVV / CVC',
  'field.pin': 'Code PIN',
  'field.documentType': 'Type de document',
  'field.reminder': 'Rappel',
  'field.collections': 'Collections',
  'field.idPhotos': 'Photos du document',
  'field.attachments': 'Pièces jointes',

  'editor.newItem': 'Nouveau : {type}',
  'editor.editItem': 'Modifier : {type}',
  'editor.titlePlaceholder': 'Titre ({type})',
  'editor.selectDocumentType': 'Choisir le type de document',
  'editor.noneSelected': 'Aucune sélection',
  'editor.optional': 'Facultatif',
  'editor.optionalFields': 'Champs facultatifs',
  'editor.reminderDate': 'Date du rappel',
  'editor.optionalTime': 'Heure (facultative)',
  'editor.shortcutHint': 'Ctrl+Entrée enregistre. Échap annule.',
  'editor.addTitle': 'Ajoutez un titre.',
  'editor.saveFailed': 'Impossible d’enregistrer cet élément.',
  'editor.photoFailed': 'Impossible de préparer cette photo.',
  'editor.attachmentFailed': 'Impossible de préparer cette pièce jointe.',
  'editor.photoNote': 'Les photos jusqu’à {mb} Mo sont chiffrées et enregistrées sur cet appareil, puis synchronisées automatiquement si la synchronisation est activée.',
  'editor.attachmentNote': 'Les fichiers sont chiffrés tels que sélectionnés et enregistrés sur cet appareil. Safe Wallet bloque les exécutables, scripts, contenus web actifs et fichiers à macros les plus courants, mais ne recherche pas de logiciels malveillants.',
  'editor.attachmentButton': 'Pièce jointe (max. {mb} Mo)',
  'editor.addingAttachment': 'Ajout de la pièce jointe…',
  'editor.preparing': 'Préparation…',
  'editor.takePhoto': 'Prendre une photo',
  'editor.choosePhoto': 'Choisir une photo',
  'editor.front': 'Recto',
  'editor.back': 'Verso',
  'editor.tapAddFront': 'Appuyez pour ajouter le recto',
  'editor.tapAddBack': 'Appuyez pour ajouter le verso',
  'editor.photoNotOnDevice': 'La photo chiffrée n’est pas enregistrée sur cet appareil.',
  'editor.pinItem': 'Épingler',
  'editor.pinned': 'Épinglé',
  'editor.deleteItem': 'Supprimer l’élément',

  'viewer.noBody': 'Aucun texte.',
  'viewer.notSet': 'Non renseigné',
  'viewer.escCloses': 'Échap ferme cette vue.',

  'attach.title': 'Pièce jointe',
  'attach.notOnDevice': 'La pièce jointe chiffrée n’est pas encore enregistrée sur cet appareil.',
  'attach.photoNotOnDevice': 'La photo chiffrée n’est pas encore enregistrée sur cet appareil.',
  'attach.openingPhoto': 'Ouverture de la photo chiffrée…',
  'attach.opening': 'Ouverture…',
  'attach.notStored': 'Non enregistré sur cet appareil',
  'attach.couldNotOpen': 'Impossible d’ouvrir cette pièce jointe.',
  'attach.previewUnavailable': 'Aucun aperçu disponible pour ce type de fichier. Téléchargez-le et ouvrez-le avec une application de confiance.',
  'attach.previewLimited': 'Aperçu limité au premier Mo.',
  'attach.openPdf': 'Ouvrir le PDF',
  'attach.download': 'Télécharger',

  'expiry.label': 'Expiration (MM/AA)',
  'expiry.month': 'Mois d’expiration',
  'expiry.chooseMonthYear': 'Choisir le mois et l’année',
  'expiry.chooseDate': 'Choisir la date d’expiration',
  'expiry.previousYear': 'Année précédente',
  'expiry.nextYear': 'Année suivante',

  'collections.createFirst': 'Créez d’abord des collections depuis le menu principal.',
  'chooser.addNew': 'Ajouter',

  'settings.title': 'Paramètres',
  'settings.account': 'Compte',
  'settings.security': 'Sécurité',
  'settings.recovery': 'Récupération',
  'settings.thisDevice': 'Cet appareil',
  'settings.appearance': 'Apparence',
  'settings.searchPrivacy': 'Confidentialité de la recherche',
  'settings.dangerZone': 'Zone sensible',
  'settings.notSignedIn': 'Non connecté',
  'settings.pinOnly': 'Code PIN uniquement',
  'settings.pinAndFingerprint': 'Code PIN + empreinte',
  'settings.changePinRow': 'Modifier le code PIN de l’application sur cet appareil. Votre code PIN actuel est requis.',
  'settings.lockNow': 'Verrouiller maintenant',
  'settings.chooseAnotherWallet': 'Choisir un autre portefeuille',
  'settings.useAnotherAccount': 'Utiliser un autre compte',
  'settings.categoryLabels': 'Libellés de catégorie',
  'settings.rowSpacing': 'Espacement des lignes',
  'settings.textSize': 'Taille du texte',
  'settings.autoLock': 'Verrouillage automatique',
  'settings.optionName': 'Nom',
  'settings.optionIcon': 'Icône',
  'settings.optionBoth': 'Les deux',
  'settings.optionLarge': 'Grand',
  'settings.optionMedium': 'Moyen',
  'settings.optionCompact': 'Compact',
  'settings.optionSmall': 'Petit',
  'settings.searchPrivacyNote': 'L’index de recherche déchiffré n’existe que sur cet appareil déverrouillé et est effacé au verrouillage du portefeuille. Les mots de passe, codes PIN, numéros de carte et de compte, codes de sécurité, numéros de documents, codes de récupération et secrets similaires ne sont jamais indexés.',
  'settings.exampleProjection': 'Exemple pour le premier élément',
  'settings.noItemsYet': 'Aucun élément pour l’instant.',
  'settings.removeWalletNote': 'Retirer ce portefeuille de ce navigateur ne supprime pas sa sauvegarde chiffrée dans le compte.',
  'settings.removeWallet': 'Retirer ce portefeuille local',

  'pin.changeTitle': 'Modifier le code PIN',
  'pin.change': 'Modifier le code PIN',
  'pin.changing': 'Modification…',
  'pin.current': 'Code PIN actuel',
  'pin.new': 'Nouveau code PIN',
  'pin.repeat': 'Répéter le nouveau code PIN',
  'pin.accountPassword': 'Mot de passe du compte',
  'pin.accountPasswordHint': 'Nécessaire pour mettre à jour la connexion sur vos autres appareils.',
  'pin.noteSynced': 'Vos éléments enregistrés n’ont pas besoin d’être rechiffrés. Comme ce portefeuille se synchronise, votre mot de passe de compte est nécessaire pour que le nouveau code PIN fonctionne aussi lors d’une connexion sur un nouvel appareil.',
  'pin.noteLocal': 'Votre code PIN actuel déverrouille ce portefeuille sur cet appareil. Vos éléments enregistrés n’ont pas besoin d’être rechiffrés.',
  'pin.errCurrent': 'Saisissez votre code PIN actuel de 6 à 12 chiffres.',
  'pin.errNew': 'Utilisez un nouveau code PIN de 6 à 12 chiffres.',
  'pin.errMismatch': 'Les deux nouveaux codes PIN ne correspondent pas.',
  'pin.errSame': 'Choisissez un nouveau code PIN différent de l’actuel.',
  'pin.errPassword': 'Saisissez le mot de passe de votre compte.',
  'pin.errFailed': 'Impossible de modifier le code PIN.',

  'fingerprint.title': 'Déverrouillage par empreinte',
  'fingerprint.settingUp': 'Configuration…',
  'fingerprint.unavailable': 'Cet appareil ne peut pas le faire.',
  'fingerprint.errOn': 'Impossible d’activer cette option.',
  'fingerprint.errOff': 'Impossible de désactiver cette option.',

  'sync.off': 'Désactivée — uniquement sur cet appareil',
  'sync.notConfigured': 'Désactivée — synchronisation non configurée',
  'sync.connecting': 'Connexion…',
  'sync.uploading': 'Activée — synchronisation de la sauvegarde chiffrée…',
  'sync.waiting': 'Activée — modifications chiffrées en attente d’envoi',
  'sync.connected': 'Activée — sauvegarde chiffrée connectée',
  'sync.offline': 'Hors ligne — sauvegarde chiffrée en pause',

  'account.signedIn': 'Connecté',
  'account.signedInAs': 'Connecté en tant que',
  'account.anotherAccount': 'Autre compte',
  'account.currentAccount': 'Compte actuel',
  'account.wallet': 'Portefeuille',
  'account.sync': 'Synchronisation',
  'account.device': 'Appareil',
  'account.signOut': 'Se déconnecter',
  'account.signOutOf': 'Se déconnecter de {account}',
  'account.email': 'E-mail',
  'account.pinLabel': 'Code PIN Safe Wallet',
  'account.pinHint': 'Votre code PIN pour ce portefeuille. Si ce compte possède déjà un portefeuille, utilisez le code PIN de celui-ci.',
  'account.pinPlaceholder': '6 à 12 chiffres',
  'account.signInTab': 'Se connecter',
  'account.createTab': 'Créer un compte',
  'account.forgotPassword': 'Mot de passe du compte oublié ?',
  'account.signInSync': 'Se connecter et synchroniser',
  'account.createSync': 'Créer un compte et synchroniser',
  'account.signInSyncTitle': 'Connexion et synchronisation',
  'account.differentSession': 'Un compte est connecté dans ce navigateur, mais ce portefeuille local n’est pas rattaché à ce compte. Ouvrez « Connexion et synchronisation » ci-dessous pour rattacher le compte propriétaire de ce portefeuille, ou déconnectez-vous d’abord pour utiliser un autre compte.',
  'account.notConfigured': 'La synchronisation n’est pas configurée pour cette installation.',
  'account.confirmEmail': 'Confirmez le compte depuis votre e-mail, puis revenez vous connecter. Ce portefeuille local n’est pas encore rattaché.',
  'account.errPin': 'Saisissez le code PIN Safe Wallet de 6 à 12 chiffres de ce portefeuille.',
  'account.errSession': 'La session du compte n’a pas pu être établie.',
  'account.connected': 'Portefeuille rattaché. La synchronisation démarre.',
  'account.connectedNoSync': 'Compte rattaché. La synchronisation n’est pas disponible dans cet environnement.',
  'account.errConnect': 'Impossible de rattacher ce compte.',
  'account.resetSent': 'Consultez vos e-mails pour le lien de réinitialisation du mot de passe.',
  'account.errReset': 'Impossible d’envoyer l’e-mail de réinitialisation.',
  'account.signedOut': 'Déconnecté du compte. Le portefeuille chiffré reste disponible sur cet appareil.',

  'pairing.advanced': 'Avancé : approuver un autre appareil',
  'pairing.advancedNote': 'À n’utiliser que si la connexion normale par mot de passe et code PIN est impossible. Comparez l’empreinte sur les deux appareils avant d’approuver.',
  'pairing.none': 'Aucun appareil en attente.',
  'pairing.invalidKey': 'Clé d’appairage invalide',
  'pairing.calculating': 'Calcul de l’empreinte…',
  'pairing.review': 'Vérifier',
  'pairing.reviewTitle': 'Vérifier le nouvel appareil',
  'pairing.fingerprint': 'Empreinte de vérification',
  'pairing.compare': 'Comparez chaque groupe avec l’empreinte affichée sur le nouvel appareil.',
  'pairing.doNotApprove': 'N’approuvez pas en cas de différence.',
  'pairing.mismatchNote': 'Cela peut signifier que la clé d’appairage a été modifiée et que la clé du portefeuille pourrait être envoyée au mauvais appareil.',
  'pairing.confirm': 'J’ai comparé les deux empreintes et elles correspondent exactement.',
  'pairing.approve': 'Approuver l’appareil',
  'pairing.approving': 'Approbation…',
  'pairing.approved': '{device} approuvé.',
  'pairing.errInvalid': 'Cette demande d’approbation contient une clé d’appairage invalide. Refusez-la et lancez une nouvelle demande.',
  'pairing.errChanged': 'La clé d’appairage a changé pendant la vérification. Annulez cette demande.',
  'pairing.errApprove': 'Impossible d’approuver cet appareil.',

  'wallet.localOnly': 'Portefeuille local uniquement',
  'wallet.lastUsedRecently': 'Utilisé récemment',
  'wallet.notConnected': 'Non rattaché à un compte',
  'wallet.availableOnDevice': 'Portefeuille disponible sur cet appareil',
  'wallet.onlyThisDevice': 'Uniquement sur cet appareil — synchronisation désactivée',

  'fingerprint.confirmBackup': 'Activer le déverrouillage par empreinte ?\n\nEnsuite, l’ouverture de ce portefeuille sur cet appareil demandera votre empreinte en plus de votre code PIN. Si l’empreinte cesse un jour de fonctionner, vous pourrez revenir avec votre connexion de secours ou un contact de confiance.',
  'fingerprint.confirmNoBackup': 'Activer le déverrouillage par empreinte ?\n\nEnsuite, l’ouverture de ce portefeuille sur cet appareil demandera votre empreinte en plus de votre code PIN. Ce portefeuille n’a pas encore de sauvegarde : si l’empreinte cesse un jour de fonctionner, il ne pourra plus être ouvert. Il est vivement conseillé d’activer d’abord la synchronisation.',

  'gate.cloudNotConfigured': 'Le cloud n’est pas encore configuré. Vous pouvez créer un portefeuille local maintenant et le rattacher plus tard depuis les paramètres.',

  'create.title': 'Créer le code PIN',
  'create.intro': 'Le code PIN déverrouille cet appareil. Votre mot de passe de compte sera distinct lorsque vous activerez la synchronisation.',
  'create.walletName': 'Nom du portefeuille',
  'create.walletNameHint': 'Affiché dans ce navigateur avant la saisie du code PIN.',
  'create.walletNamePlaceholder': 'Alex, Sam, Coffre familial…',
  'create.deviceName': 'Nom de l’appareil',
  'create.appPin': 'Code PIN',
  'create.repeatPin': 'Répéter le code PIN',
  'create.creating': 'Création…',
  'create.createWallet': 'Créer le portefeuille',
  'create.errPin': 'Utilisez un code PIN de 6 à 12 chiffres.',
  'create.errMismatch': 'Les deux codes PIN ne correspondent pas.',
  'create.errFailed': 'Impossible de créer ce portefeuille.',
  'create.errHello': 'Impossible d’activer le déverrouillage par empreinte.',
  'create.fingerprintTitle': 'Ajouter l’empreinte ou le visage ?',
  'create.fingerprintCopy': 'Un second verrou, pour qu’une copie volée de votre portefeuille ne puisse pas être forcée. Vous saisissez toujours votre code PIN.',
  'create.turnOn': 'Activer',
  'create.notNow': 'Pas maintenant',

  'unlock.title': 'Déverrouiller Safe Wallet',
  'unlock.unlock': 'Déverrouiller',
  'unlock.opening': 'Ouverture…',
  'unlock.withFingerprint': 'Déverrouiller avec l’empreinte',
  'unlock.wait': 'Patientez {seconds}s',
  'unlock.tooManyAttempts': 'Trop de tentatives. Réessayez dans {seconds}s.',
  'unlock.tooMany': 'Trop de codes PIN incorrects',
  'unlock.tooManyBackup': 'Prenez un instant. Vous pouvez continuer d’essayer ci-dessous, ou récupérer votre accès avec votre connexion de secours ou un contact de confiance.',
  'unlock.tooManyLocal': 'Prenez un instant et réessayez avec attention. Ce portefeuille n’existe que sur cet appareil, il n’y a donc aucune sauvegarde de secours.',
  'unlock.forgotPin': 'Code PIN Safe Wallet oublié ?',
  'unlock.errFailed': 'Impossible d’ouvrir ce portefeuille.',

  'chooser.chooseWallet': 'Choisir un portefeuille',
  'chooser.eachHasPin': 'Chaque portefeuille enregistré a son propre code PIN dans ce navigateur.',
  'chooser.current': 'Actuel',
  'chooser.addAnother': 'Ajouter un autre compte',

  'existing.title': 'Portefeuille existant',
  'existing.heading': 'Ouvrir mon portefeuille',
  'existing.intro': 'Utilisez votre mot de passe de compte et votre code PIN Safe Wallet pour ouvrir ce portefeuille sur cet appareil.',
  'existing.openWallet': 'Ouvrir le portefeuille',
  'existing.forgotPin': 'Code PIN Safe Wallet oublié ?',
  'existing.advanced': 'Avancé : approuver depuis un autre appareil',
  'existing.advancedNote': 'À n’utiliser que pour les anciens portefeuilles bêta qui n’ont pas encore été mis à jour pour la connexion par mot de passe et code PIN.',
  'existing.requesting': 'Demande en cours…',
  'existing.requestApproval': 'Demander l’approbation de l’appareil',
  'existing.approvalTitle': 'Approbation de l’appareil',
  'existing.unavailable': 'Indisponible',
  'existing.calculating': 'Calcul…',
  'existing.mismatchNote': 'Une différence signifie que la clé d’appairage a peut-être été modifiée en transit. Annulez la demande et ne l’approuvez pas.',
  'existing.cancelRequest': 'Annuler la demande',
  'existing.approved': 'Appareil approuvé',
  'existing.setPin': 'Définir un code PIN',
  'existing.setPinNote': 'Ce code PIN protège la clé du portefeuille approuvée sur cet appareil. Vous pouvez utiliser le même code PIN Safe Wallet que sur vos autres appareils personnels.',
  'existing.finishing': 'Finalisation…',
  'existing.errPin': 'Utilisez un code PIN Safe Wallet de 6 à 12 chiffres.',
  'existing.errNoWallet': 'Ce compte n’a pas encore de Safe Wallet. Créez plutôt un nouveau portefeuille.',
  'existing.errUpgrade': 'Une mise à jour unique est nécessaire. Ouvrez ce portefeuille une fois sur un appareil où il fonctionne déjà, activez-y la synchronisation, puis réessayez.',
  'existing.errRequest': 'Impossible de demander l’approbation de l’appareil.',
  'existing.errCancel': 'Impossible d’annuler la demande d’approbation ; elle expirera automatiquement.',
  'existing.errFinish': 'Impossible de terminer l’approbation de l’appareil.',
  'existing.errPairingInvalid': 'La clé d’appairage locale est invalide. Annulez et lancez une nouvelle demande.',
  'existing.errCancelled': 'Cette demande d’approbation a été annulée. Lancez une nouvelle demande.',
  'existing.errExpired': 'Cette demande d’approbation a expiré. Lancez une nouvelle demande.',

  'status.onDeviceOnly': 'Uniquement sur cet appareil',
  'status.syncing': 'Synchronisation…',
  'status.synced': 'Synchronisé',
  'status.offline': 'Hors ligne',
  'status.saving': 'Enregistrement…',
  'status.savingLocal': 'Enregistrement sur cet appareil…',
  'status.openingDatabase': 'Ouverture de la base locale…',
  'status.couldNotStart': 'Démarrage impossible',
  'status.errInit': 'Impossible de démarrer Safe Wallet.',
  'status.errDatabase': 'La base de données locale n’est pas prête.',
  'menu.closeMenu': 'Fermer le menu',
  'action.showAll': 'Tout afficher',

  'conflict.collection': 'Collection',
  'conflict.deletedVersion': 'Une version supprimée entre en conflit avec une autre modification',
  'conflict.multipleChanges': 'Plusieurs modifications hors ligne',
  'conflict.title': 'Conflit',
  'conflict.chooseVersion': 'Choisissez la version à conserver',
  'conflict.note': 'Les deux versions chiffrées sont conservées jusqu’à votre choix. Une version supprimée peut être choisie délibérément.',
  'conflict.loading': 'Chargement des versions…',
  'conflict.deleted': 'Version supprimée',
  'conflict.resolving': 'Résolution…',
  'conflict.keepDeleted': 'Conserver la suppression',
  'conflict.useThis': 'Utiliser cette version',
  'conflict.errOpen': 'Impossible d’ouvrir les versions en conflit.',
  'conflict.errResolve': 'Impossible de résoudre ce conflit.',
  'conflict.screenNote': 'Les modifications faites hors ligne sur plusieurs appareils restent chiffrées et sont conservées jusqu’à ce que vous choisissiez la version à garder.',
  'conflict.none': 'Aucun conflit.',

  'collections.newName': 'Nom de la nouvelle collection',
  'collections.note': 'Les collections sont des dossiers privés. Un élément peut appartenir à plusieurs collections.',
  'collections.confirmDelete': 'Supprimer la collection « {name} » ? Les éléments restent dans Safe Wallet.',

  'item.confirmDelete': 'Supprimer « {title} » ? Cet élément pourra être restauré depuis l’historique de sauvegarde pendant une durée limitée.',
  'reminder.confirmDone': 'Marquer ce rappel comme terminé ?\n\nLa date du rappel reste sur l’élément.',
  'reset.confirmOther': 'Retirer « {name} » de ce navigateur ? Sa sauvegarde chiffrée dans le compte n’est pas supprimée et vos autres portefeuilles sur ce navigateur ne sont pas touchés. Il vous faudra le compte de sauvegarde et le code PIN pour le rajouter ici.',
  'reset.confirmLast': 'Retirer ce portefeuille local de ce navigateur ? Les données chiffrées déjà synchronisées ne sont pas supprimées du compte. Les modifications en attente d’envoi et l’approbation de cet appareil seront effacées.',

  'merge.confirmAdd': 'Ce compte possède déjà un portefeuille. Ajouter vos {items}, photos et fichiers compris, et basculer vers ce portefeuille ?\n\nVotre portefeuille actuel est conservé sur ce navigateur jusqu’à ce que vous le retiriez.',
  'merge.notice': '{items} ont été ajoutés à ce portefeuille, avec leurs photos et fichiers. Votre ancien portefeuille « {name} » est toujours sur ce navigateur. Une fois sa sauvegarde envoyée, vous pourrez le retirer ci-dessous.',
  'merge.removeOld': 'Retirer l’ancien portefeuille',
  'merge.backingUp': 'Sauvegarde en cours…',
  'merge.dismiss': 'Masquer',
  'merge.confirmRemoveOld': 'Retirer l’ancien portefeuille « {name} » de ce navigateur ?\n\nSes éléments sont déjà copiés dans ce portefeuille et sauvegardés sur votre compte. Cela n’efface que l’ancienne copie locale sur ce navigateur.',
  'merge.errMismatch': 'Le portefeuille ouvert ne correspond pas au compte choisi pour la copie. Rien n’a été retiré du portefeuille d’origine.',
  'merge.errOpenLocal': 'Ouvrez le portefeuille local avant d’ajouter ses éléments à un autre portefeuille.',
  'merge.errNoWallet': 'Ce compte n’a pas de portefeuille auquel ajouter des éléments.',
  'merge.errKeyPackage': 'Ouvrez une fois le portefeuille du compte sur l’appareil où il fonctionne déjà, puis réessayez.',
  'merge.errPin': 'Ce code PIN n’ouvre pas le portefeuille déjà présent sur ce compte. Saisissez le code PIN de ce portefeuille.',

  'pin.errNoSync': 'La synchronisation n’est pas configurée, le code PIN ne peut donc pas être mis à jour pour les nouveaux appareils.',
  'pin.errNoEmail': 'Aucune adresse e-mail de compte n’est enregistrée pour ce portefeuille sur cet appareil.',
  'pin.errOffline': 'Vous semblez hors ligne. Reconnectez-vous pour modifier le code PIN utilisé lors de la connexion sur un nouvel appareil.',
  'pin.errWrongPassword': 'Ce mot de passe de compte est incorrect.',
  'pin.errDeviceUnavailable': 'Cet appareil n’est pas disponible.',
  'pin.changedBoth': 'Code PIN modifié sur cet appareil et pour la connexion sur de nouveaux appareils.',
  'pin.changedLocal': 'Code PIN modifié. Utilisez le nouveau code la prochaine fois que cet appareil se verrouille.',

  'recover.accountTitle': 'Compte Safe Wallet',
  'recover.passwordChanged': 'Mot de passe modifié',
  'recover.passwordChangedNote': 'Reconnectez-vous avec le nouveau mot de passe du compte. Votre code PIN et votre portefeuille chiffré n’ont pas été modifiés.',
  'recover.continue': 'Continuer',
  'recover.choosePassword': 'Choisir un nouveau mot de passe',
  'recover.choosePasswordNote': 'Cela modifie uniquement le mot de passe du compte de synchronisation. Votre code PIN reste inchangé et, à lui seul, ce mot de passe ne permet pas d’ouvrir votre portefeuille chiffré sur un nouvel appareil.',
  'recover.checkingLink': 'Vérification du lien de récupération…',
  'recover.newPassword': 'Nouveau mot de passe du compte',
  'recover.repeatPassword': 'Répéter le nouveau mot de passe',
  'recover.updating': 'Mise à jour…',
  'recover.updatePassword': 'Mettre à jour le mot de passe',
  'recover.errShort': 'Utilisez au moins 8 caractères.',
  'recover.errMismatch': 'Les deux mots de passe ne correspondent pas.',
  'recover.errUpdate': 'Impossible de mettre à jour le mot de passe du compte.',

  'recover.walletTitle': 'Récupération du portefeuille',
  'recover.freshVerification': 'Récupérer un portefeuille exige toujours une nouvelle vérification de votre compte. Safe Wallet ne demande jamais votre code à un contact de confiance.',
  'recover.useOnlyWhen': 'À n’utiliser que si aucun de vos appareils ne peut réinitialiser votre code PIN. Il vous faut une nouvelle vérification par e-mail et l’approbation d’un contact Safe Wallet de confiance.',
  'recover.accountEmail': 'E-mail du compte',
  'recover.emailCode': 'Code de vérification reçu par e-mail',
  'recover.sendAnother': 'Envoyer un autre code',
  'recover.authenticator': 'Authentificateur',
  'recover.authenticatorCode': 'Code de l’authentificateur',
  'recover.verifyStart': 'Vérifier l’e-mail et commencer',
  'recover.verifyContinue': 'Vérifier l’e-mail et continuer',
  'recover.deviceFingerprint': 'Empreinte de l’appareil qui récupère',
  'recover.readFingerprint': 'Lisez cette empreinte à votre contact de confiance lors d’un appel en direct. Il doit vous appeler sur des coordonnées qu’il possédait déjà — jamais sur un numéro qu’on lui a envoyé pour l’occasion.',
  'recover.status': 'État :',
  'recover.waitingEnds': 'Fin du délai d’attente :',
  'recover.expires': 'Expire le :',
  'recover.cancel': 'Annuler la récupération',
  'recover.setNewPin': 'Définir un nouveau code PIN',
  'recover.keyRebuilt': 'La clé de votre portefeuille a été reconstituée uniquement dans ce navigateur. La protection de récupération est désormais épuisée et doit être reconfigurée.',
  'recover.deviceName': 'Nom de l’appareil',
  'recover.newPin': 'Nouveau code PIN',
  'recover.repeatPin': 'Répéter le code PIN',

  'invite.securityConfirmation': 'Confirmation de sécurité',
  'invite.title': 'Invitation de récupération',
  'invite.helpSomeone': 'Aider une personne de confiance',
  'invite.invitedBy': 'Invité par',
  'invite.askedYou': 'Cette personne vous demande d’être son contact de confiance pour la récupération.',

  'invite.cannotSee': 'Vous ne pouvez pas voir son portefeuille.',
  'invite.cannotSeeNote': 'Ce qui y est enregistré reste chiffré et privé.',
  'invite.cannotRecover': 'Vous ne pouvez pas le récupérer seul.',
  'invite.cannotRecoverNote': 'Vous n’intervenez qu’après que la personne a lancé elle-même la récupération.',
  'invite.nothingToRemember': 'Rien à retenir de votre côté.',
  'invite.nothingToRememberNote': 'Safe Wallet prépare tout en sécurité dès que vous acceptez.',
  'invite.enterPin': 'Saisissez votre code PIN',
  'invite.confirming': 'Confirmation…',
  'invite.decline': 'Refuser',
  'invite.accept': 'Accepter l’invitation',
  'invite.confirmWithPin': 'Confirmer avec votre code PIN',
  'invite.acceptTitle': 'Accepter l’invitation de récupération',
  'invite.confirmBecome': 'Confirmez que vous voulez devenir contact de récupération pour :',
  'invite.declineTitle': 'Refuser l’invitation',
  'invite.declineQuestion': 'Ne pas devenir contact de récupération ?',
  'invite.invitationFrom': 'L’invitation de',
  'invite.keep': 'Conserver l’invitation',
  'invite.accepted': 'Invitation acceptée',
  'invite.nowContact': 'Vous êtes maintenant contact de récupération',
  'invite.nothingUnless': 'Vous n’avez rien à faire, sauf si',
  'invite.inboxTitle': 'Invitations de récupération',
  'invite.review': 'Examiner l’invitation',
  'invite.errConfirm': 'Impossible de confirmer.',
  'invite.errAccept': 'Impossible d’accepter cette invitation.',
  'invite.errDecline': 'Impossible de refuser cette invitation.',

  'protect.preparing': 'Préparation de la protection de récupération…',
  'protect.addPerson': 'Ajouter une personne de confiance',
  'protect.addPersonNote': 'Une personne de confiance peut vous aider à retrouver l’accès à votre portefeuille. Elle ne peut pas voir votre portefeuille, ni le récupérer sans vous.',
  'protect.addSoYouCan': 'Ajoutez une personne de confiance pour pouvoir revenir si vous perdez votre code PIN ou votre appareil.',
  'protect.mustHaveAccount': 'Elle doit déjà avoir un compte Safe Wallet.',
  'protect.useTheirEmail': 'Utilisez l’adresse e-mail liée à son Safe Wallet.',
  'protect.emailLabel': 'E-mail Safe Wallet de la personne de confiance',
  'protect.emailPlaceholder': 'nom@exemple.fr',
  'protect.send': 'Envoyer l’invitation',
  'protect.yourPeople': 'Vos personnes de confiance',
  'protect.onlyYouSee': 'Vous seul voyez cette liste.',
  'protect.waiting': 'En attente de son acceptation',
  'protect.pending': 'En attente',
  'protect.canHelp': 'Peut aider quand vous demandez une récupération',
  'protect.active': 'Active',
  'protect.protectionActive': 'La protection de récupération est active',
  'protect.becomesActive': 'La protection de récupération devient active dès qu’une personne invitée accepte.',
  'protect.errLoad': 'Impossible de charger la protection de récupération.',
  'protect.errSelf': 'Choisissez un autre utilisateur Safe Wallet.',
  'protect.errNoAccount': 'Aucun compte Safe Wallet n’a été trouvé pour cette adresse. Demandez à cette personne de créer et de confirmer son compte d’abord.',
  'protect.errNotReady': 'Ce compte Safe Wallet n’est pas encore prêt pour les invitations de récupération. Demandez à cette personne d’ouvrir et de déverrouiller une fois son Safe Wallet mis à jour, puis réessayez.',
  'protect.errCheck': 'Impossible de vérifier ce compte Safe Wallet.',
  'protect.errSend': 'Impossible d’envoyer cette invitation.',
  'invite.willBeRemoved': 'sera supprimée. Cette personne pourra vous réinviter plus tard.',
  'invite.asksForHelp': 'demande de l’aide pour retrouver l’accès à son portefeuille.',
  'protect.notSetUp': 'Non configurée',
  'protect.checking': 'Vérification…',
  'reminder.done': 'Terminé',
  'reminder.doneOn': 'Terminé le {date}',
  'invite.enterWalletPin': 'Saisissez votre code PIN Safe Wallet',
  'invite.confirmInviteNote': 'Confirmez que vous voulez inviter cette personne comme contact de récupération.',
  'invite.confirmInvite': 'Confirmer l’invitation',
  'recover.startTitle': 'Démarrer la récupération',
  'recover.continueTitle': 'Poursuivre la récupération',
  'invite.invitedYouTo': 'vous a invité à être son contact de confiance pour la récupération.',
  'approve.inboxTitle': 'Quelqu’un a besoin de votre aide',
  'approve.isRecovering': 'essaie de retrouver l’accès à son portefeuille.',
  'approve.review': 'Examiner la demande',
  'approve.title': 'Autoriser le retour dans le portefeuille ?',
  'approve.fingerprintLabel': 'Code affiché sur son nouvel appareil',
  'approve.callFirst': 'Appelez cette personne d’abord — sur un numéro que vous aviez déjà, jamais sur un numéro qu’on vous a envoyé. Demandez-lui de lire le code affiché sur son écran et vérifiez qu’il correspond exactement à celui-ci.',
  'approve.onlyIfSure': 'N’autorisez que si le code correspond et que vous êtes sûr qu’il s’agit bien d’elle. Sinon, prévenez-la immédiatement pour qu’elle annule la demande.',
  'approve.approve': 'Les codes correspondent — autoriser',
  'approve.approving': 'Autorisation…',
  'approve.notNow': 'Pas maintenant',
  'approve.done': 'Autorisé. Cette personne peut maintenant revenir.',
  'approve.errApprove': 'Impossible d’autoriser cette demande.',
  'approve.waitUntil': 'Elle pourra continuer à partir de {time}.',
};

export const plurals: Plurals = {
  items: { one: '{count} élément', other: '{count} éléments' },
  minutes: { one: '{count} minute', other: '{count} minutes' },
  queued: { one: '{count} modification en attente', other: '{count} modifications en attente' },
  helpers: { one: '{count} personne de confiance prête à aider.', other: '{count} personnes de confiance prêtes à aider.' },
};
